import React from 'react'
import Svg from './../Svg'

export default ({
  width = 34,
  height = 27,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 31 25"
    aria-label={ ariaLabel }
  >
    <path d="M17.63,0A4.56,4.56,0,0,1,22.1,3.55h0l.12.52h5A3.58,3.58,0,0,1,30.8,7.65h0V21.24A3.76,3.76,0,0,1,27,25H3.76A3.76,3.76,0,0,1,0,21.24H0V7.65A3.58,3.58,0,0,1,3.58,4.07h5l.12-.52A4.59,4.59,0,0,1,13.17,0h4.46Zm0,1.54H13.17a3,3,0,0,0-3,2.36h0L9.94,5a.76.76,0,0,1-.75.59H3.58a2,2,0,0,0-2,2h0V21.24a2.21,2.21,0,0,0,2.22,2.22H27a2.22,2.22,0,0,0,2.22-2.22h0V7.65a2,2,0,0,0-2-2H21.61A.77.77,0,0,1,20.86,5h0L20.6,3.9a3,3,0,0,0-3-2.36ZM15.4,8.11a6.47,6.47,0,1,1-6.47,6.47A6.47,6.47,0,0,1,15.4,8.11Zm0,1.54a4.93,4.93,0,1,0,4.93,4.93A4.94,4.94,0,0,0,15.4,9.65ZM5.21,7.87a1,1,0,1,1-1,1A1,1,0,0,1,5.21,7.87Z"/>
  </Svg>
